'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _prep2.default)({
    name: 'push',
    immutable: 'push',
    array: function array() {
        for (var _len = arguments.length, newValues = Array(_len), _key = 0; _key < _len; _key++) {
            newValues[_key] = arguments[_key];
        }

        return function (value) {
            return [].concat(_toConsumableArray(value), newValues);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/push.js
// module id = 270
// module chunks = 35783957827783